<template>
  <div class="project-wampper production-safety">
    <div class="content-left">
      <div class="safety-left">
        <div class="safety-time">
          <p class="font-64DD17 font-size-22">安全施工：
            <span class="time-content">{{ buildDate }}</span>
          </p>
          <p class="font-64DD17 font-FFFFFF-50 font-size-18 fontweight">
            <span class="p-r10">现场负责人员：</span>
            <span class="p-l-r10">刘飞</span>
            <span>15127319880</span>
          </p>
          <p class="font-64DD17 font-FFFFFF-50 font-size-18 fontweight">
            <span class="p-r10">现场值班人员：</span>
            <span class="p-l-r10">王敏</span>
            <span>13127319708</span>
          </p>
        </div>
        <div class="weather-module">
          <weatherModule></weatherModule>
        </div>
        <div class="title-bg">进场情况</div>
        <div class="public-bg font-size-16 in-case font-FFFFFF-50">
          <p>
            <span>施工人员</span>
            实际: 
            <i class="f2899FF padd10">{{enterArena.incase_actualbuilder}}</i>  
            计划: 
            <i class="f2899FF padd10">{{enterArena.incase_planbuilder}} </i> (人次)
          </p>
          <p>
            <span>机械台班</span>
            实际: 
            <i class="f2899FF padd10">{{enterArena.incase_actualmachine}}</i>   
            计划: 
            <i class="f2899FF padd10">{{enterArena.incase_palnmachine}}</i> (台)
          </p>
          <p>
            <span>材料进场</span>
            <i class="f2899FF padd10">{{enterArena.incase_materials}}</i> (批次)
          </p>
        </div>
        <div class="title-bg title-bg-149">危险源提示</div>
        <div class="dangerous-tip font-FFFFFF-50 font-size-16">
          <div class="tip-list">
            <p class="tip-first-child" v-for="(item,index) in scrollSafetyData" :key="index">
              <i class="bg-biaoji" :class="item.imgName"></i>
              <span>{{item.typeName}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="content-right safety-right">
      <!-- 这部分是点击对应的摄像头打开对应的监控 -->
      <!-- <div class="BIM-camera" :class="changeCameraSize? 'camerabig' : 'camerasmall'" v-if="bimCamerashow">
        <BIMCamera 
          @close="bimCamerashow=false" 
          :clickBIMCarmerSrc="clickBIMCarmerSrc" 
          :clickBIMCarmerName="clickBIMCarmerName" 
          @changeCamera="changeCamera" 
          :changeCameraSize="changeCameraSize"
        ></BIMCamera>
      </div> -->
      <div class="all-camera" v-if="bimCamerashow" >
        <div class="wapper-title">
          <span v-if="clickBIMCameraBigShow">{{clickBIMCarmerName}}</span>
      
          <i class="safety-icon icon-size" v-if="clickBIMCameraBigShow" @click="clickCloseSize"></i>
          <i class="safety-icon icon-close" @click="closeAllCamera"></i>
        </div>
        <div class="children-camera" v-for="(item,index) in allCameraSrcList" :key="index">
          <div class="camera-content" :class="clickBIMCameraBigShow && index == clickindex  ? 'css-camera-big': ''">
            <BIMCamera
              @changeCamera="changeCamerabim(item,index)"
              :clickBIMCarmerSrc="item.carmerSrc" 
              :clickBIMCarmerName="item.carmerName" 
              :changeCameraSize="changeCameraSize"
            ></BIMCamera>
          </div>
        </div> 
      </div>
      <iframe
        ref="progressSafetyBIMIframe"
        frameborder="0"
        width="100%"
        height="100%"  
        @load="BIMIframeLoading"
        :src="progressSafetyBIMSrc">
      </iframe>
    </div>
  </div>
</template>

<script>
import weatherModule from "../productionSafetyCommon/weatherModule";
import BIMCamera from "../productionSafetyCommon/BIMCamera"
export default {
  name: "Productionsafety",
  data() {
    return {
      enterArena:{},  // 进场情况参数
      progressSafetyBIMIframe: null,
      scrollSafetyData: [
        {
          imgName: 'quality_srike',
          typeName: '物体打击'
        },
        {
          imgName: 'quality_fire',
          typeName: '火灾'
        },
        {
          imgName: 'quality_dke',
          typeName: '中毒和窒息'
        },
        {
          imgName: 'quality_mechianical',
          typeName: '机械伤害'
        },
        {
          imgName: 'quality_vehicleinjury',
          typeName: '车辆伤害'
        },
        {
          imgName: 'quality_craneinjury',
          typeName: '起重伤害'
        },
        {
          imgName: 'quality_electricshock',
          typeName: '触电'
        },
        {
          imgName: 'quality_burn',
          typeName: '灼伤'
        },
        {
          imgName: 'quality_skydiving',
          typeName: '高空坠落'
        },
        {
          imgName: 'quality_collapse',
          typeName: '坍塌'
        },
        {
          imgName: 'quality_gunpowder',
          typeName: '火药爆炸'
        },
        {
          imgName: 'quality_otherdanger',
          typeName: '其他伤害'
        },
      ],
      bimViewID: [
        "ab71b9cd-2167-4a77-894c-1156ad6327af",  // "高空坠落"
        "2fde4996-075b-4c13-b797-0babd11f9101",  //"默认视点"
        // "1cdd3509-beef-44fb-9c5a-05c0b7b41426",  //"默认视点"
      ],   // 点击左边危险源提示的按钮，跳转到模型对应视点

      addSegLinePointsArr: [
        {x: 1029.7420075055586, y: -1.1368683772161603e-13, z: -20.65721941604477},
        {x: 1029.7420075055586, y: -1.1368683772161603e-13, z: -60.65721941604477},
        {x: 1029.7420075055586, y: -1.1368683772161603e-13, z: -104.65721941604477},
        {x: 1029.7420075055586, y: -1.1368683772161603e-13, z: -144.65721941604477},
        {x: 1029.7420075055586, y: -1.1368683772161603e-13, z: -184.65721941604477},
        {x: 1029.7420075055586, y: -1.1368683772161603e-13, z: -224.65721941604477},
        {x: 1029.7420075055586, y: -1.1368683772161603e-13, z: -264.65721941604477},
        {x: 1029.7420075055586, y: -1.1368683772161603e-13, z: -304.65721941604477},
        {x: 1029.7420075055586, y: -1.1368683772161603e-13, z: -340.65721941604477},
        {x: 1029.7420075055586, y: -1.1368683772161603e-13, z: -380.65721941604477},
        {x: 1029.7420075055586, y: -1.1368683772161603e-13, z: -400.65721941604477},
        {x: 1029.7420075055586, y: -1.1368683772161603e-13, z: -438.65721941604477},
        {x: 1029.7420075055586, y: -1.1368683772161603e-13, z: -442.65721941604477},

        {x: 1021.7420075055586, y: -1.1368683772161603e-13, z: -443.65721941604477},
        {x: 980.7420075055586, y: -1.1368683772161603e-13, z: -443.65721941604477},
        {x: 940.7420075055586, y: -1.1368683772161603e-13, z: -443.65721941604477},
        {x: 900.7420075055586, y: -1.1368683772161603e-13, z: -443.65721941604477},
        {x: 860.7420075055586, y: -1.1368683772161603e-13, z: -443.65721941604477},
        {x: 820.7420075055586, y: -1.1368683772161603e-13, z: -443.65721941604477},
        {x: 780.7420075055586, y: -1.1368683772161603e-13, z: -443.65721941604477},
        {x: 740.7420075055586, y: -1.1368683772161603e-13, z: -443.65721941604477},
        {x: 730.7420075055586, y: -1.1368683772161603e-13, z: -440.65721941604477},

        {x: 730.7420075055586, y: -1.1368683772161603e-13, z: -400.65721941604477},
        {x: 730.7420075055586, y: -1.1368683772161603e-13, z: -360.65721941604477},
        {x: 730.7420075055586, y: -1.1368683772161603e-13, z: -320.65721941604477},
        {x: 730.7420075055586, y: -1.1368683772161603e-13, z: -280.65721941604477},
        {x: 730.7420075055586, y: -1.1368683772161603e-13, z: -240.65721941604477},
        {x: 727.7420075055586, y: -1.1368683772161603e-13, z: -232.65721941604477},

        {x: 710.7420075055586, y: -1.1368683772161603e-13, z: -232.65721941604477},
        {x: 700.7420075055586, y: -1.1368683772161603e-13, z: -232.65721941604477},
        {x: 660.9438820643259, y: -1.1368683772161603e-13, z: -232.65721941604477},
        {x: 620.9438820643259, y: -1.1368683772161603e-13, z: -232.65721941604477},
        {x: 580.2779959896321, y: -1.1368683772161603e-13, z: -232.65721941604477},
        {x: 540.7250969522632, y: -1.1368683772161603e-13, z: -232.65721941604477},
        {x: 500.38272756728657, y: 1.1368683772161603e-13, z: -232.65721941604477},
        {x: 486.38272756728657, y: 1.1368683772161603e-13, z: -232.65721941604477},
        {x: 486.38272756728657, y: 1.1368683772161603e-13, z: -220.65721941604477},

        {x: 485.38272756728657, y: 1.1368683772161603e-13, z: -190.65721941604477},
        {x: 485.38272756728657, y: 1.1368683772161603e-13, z: -160.65721941604477},
        {x: 485.38272756728657, y: -1.1368683772161603e-13, z: -138.65721941604477},
        {x: 485.38272756728657, y: -1.1368683772161603e-13, z: -98.65721941604477},
        {x: 485.38272756728657, y: -1.1368683772161603e-13, z: -58.65721941604477},
        {x: 485.38272756728657, y: -1.1368683772161603e-13, z: -23.65721941604477},

        {x: 490.38272756728657, y: -1.1368683772161603e-13, z: -20.65721941604477},

        {x: 530.38272756728657, y: -1.1368683772161603e-13, z: -20.65721941604477},
        {x: 578.8425910284445, y: -1.1368683772161603e-13, z: -20.65721941604477},
        {x: 608.8425910284445, y: -1.1368683772161603e-13, z: -20.65721941604477},
        {x: 653.8144326972885, y: -1.1368683772161603e-13, z: -20.65721941604477},
        {x: 703.8144326972885, y: -1.1368683772161603e-13, z: -20.65721941604477},
        {x: 748.7596704958705, y: -1.1368683772161603e-13, z: -20.65721941604477},
        {x: 808.7596704958705, y: -1.1368683772161603e-13, z: -20.65721941604477},
        {x: 851.2329734695503, y: -1.1368683772161603e-13, z: -20.65721941604477},
        {x: 901.2329734695503, y: -1.1368683772161603e-13, z: -20.65721941604477},
        {x: 949.7936906602063, y: -1.1368683772161603e-13, z: -20.65721941604477},
        {x: 989.7936906602063, y: -1.1368683772161603e-13, z: -20.65721941604477},
        {x: 1021.5230708002454, y: -1.1368683772161603e-13, z: -20.65721941604477},
      ],
      addInArr:[
        {x: 1399.7420075055586, y: -1.1368683772161603e-13, z: -120.65721941604477},
      ],
      addOutArr:[
        {x: 1399.7420075055586, y: -1.1368683772161603e-13, z: -120.65721941604477},
      ],
      changeCameraSize: true,
      // addPointArr为摄像头的相关配置参数
      addPointArr: [
        // {icon: 'camera',modelid:"358",idname: 'E92137852'},   
        // {icon: 'camera',modelid:"447",idname: 'G63355051'},
        {icon: 'camera',modelid:"497",idname: 'F96489163-1',x: 100, y: 0, z: 10, titleName:'4号库',},
        {icon: 'camera',modelid:"501",idname: 'F96489163-2',x: -30, y: 0, z: 10, titleName:'3号库',},
        {icon: 'camera',modelid:"386",idname: 'F96489163-6',x: 0, y: 0, z: -60, titleName:'2号库',},
        {icon: 'camera',modelid:"402",idname: 'F96489163-5',x: 0, y: 0, z: -60, titleName:'1号库',}
      ],  
      allCameraSrcList: [],  // 所有摄像头的相关参数
      bimCamerashow: false,   // 摄像头的显示隐藏
      buildDate: "",  // 安全施工时间
      progressSafetyBIMSrc: '',   // BIM地址
      // clickBIMCarmerID: '', // 点击的摄像头的ID
      // clickBIMCarmerSrc: '', // 点击的摄像头的src
      clickBIMCarmerName: '', // 点击的摄像头的name
      clickBIMCameraBigShow: false, // 点击放大的监控摄像头
      clickindex: -1, // 记录点击放大的是哪一个监控，初始化为-1
    };
  },
  props: {},
  components: {
    weatherModule,
    BIMCamera
  },
  mounted() {
    let _this = this;
    window.onresize = () => {
      this.mainMenuNone()
    }
    // 请求接口加载左侧进场情况
    this.getEnterArenaFun();
    this.entertimer = setInterval(() => {
      this.getEnterArenaFun()
    }, 5000)
    this.cameraSrcGetVideo();


    this.progressSafetyBIMSrc = this.$project.projectData.platform.progressSafety

    this.timer = setInterval(function() {
      _this.buildDate = _this.difference(_this.$project.projectData.startDate, new Date()); // 修改date
    }, 1000);
  },
  methods: {
    changeCamerabim(item,index){
      console.log('===点击',item)
      this.changeCameraSize = false;
      this.clickBIMCameraBigShow = true;
      this.clickindex = index;
      this.clickBIMCarmerName = item.carmerName;
    },
    closeAllCamera(){
      this.clickindex = -1; // 判断的是点击的哪一个，初始化或者关闭时候赋值为-1
      this.bimCamerashow=false;
      this.changeCameraSize = false;
      this.clickBIMCameraBigShow = false;
    },
    // 接口返回进场情况
    getEnterArenaFun(){
      let _this = this;
      let url = `${window.pubilc_config.webserverurl}/api/Daxing/Daxing/`
      _this.$axios
        .get(url+'incase')
        .then(res=>{
          if (res.status == 200) {
            _this.enterArena = res.data;
          }
        }).catch(err=>{
          console.log(err,'===api/Daxing/Daxing/incase')
        })
    },
    difference(beginTime, endTime) {
      let dateBegin = new Date(beginTime);
      let dateEnd = new Date(endTime);
      let dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差的毫秒数
      let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
      let leave1 = dateDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      let hours = Math.floor(leave1 / (3600 * 1000)); //计算出小时数
      //计算相差分钟数
      let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      let minutes = Math.floor(leave2 / (60 * 1000)); //计算相差分钟数
      minutes = minutes < 10 ? "0" + minutes : minutes;
      //计算相差秒数
      let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      let seconds = Math.round(leave3 / 1000);
      seconds = seconds < 10 ? "0" + seconds : seconds;
      return (
        dayDiff + "天" + hours + "小时" + minutes + "分钟" + seconds + "秒"
      );
    },
    BIMIframeLoading(){
      let _this = this;
      let iframeModelRef = _this.$refs.progressSafetyBIMIframe.contentWindow.model; 
      _this.progressSafetyBIMIframe = _this.$refs.progressSafetyBIMIframe.contentWindow;
      _this.mainMenuNone()
      iframeModelRef.BIM365API.Events.finishRender.on('default',()=>{
        // let viewpoints = iframeModelRef.BIM365API.Data.getMainModel().activeView.getViewpointList();// 获取全部视点
        // // console.log(viewpoints)
         
        // let viewpointoverride = JSON.parse(viewpoints.viewpoint[0].override)
        // iframeModelRef.BIM365API.Context.
        // setActiveCameraPositionAnimation(viewpointoverride.cameraPosition,viewpointoverride.cameraRotation,viewpointoverride.controlPostion)
        _this.addPointOfFree();
        // _this.addINOutIcon();   // 添加两个箭头锚点
        setTimeout(()=>{
          for(let i = 0; i<_this.addPointArr.length; i++){
            _this.BIMaddPoint(_this.addPointArr[i])
          }
        },10)
      }); 
    },
    mainMenuNone(){//隐藏底部导航条
      let mainMenu = this.progressSafetyBIMIframe.document.getElementById("app").children[0].children;  //获取要隐藏的div父级对象
      if(typeof mainMenu != 'object'){
        return
      }else{
        let time = setInterval(()=>{  //设置定时循环判断是否获取到id
          if(mainMenu[0].id == 'mainMenu'||mainMenu[0].className == 'wrapper'){
            mainMenu[0].style.display = 'none'
            clearInterval(time)
          }else{
            return
          }
        },100)
      }
    },
    BIMaddPoint(ele){
      let _this = this;
      let iframeModelRef = _this.$refs.progressSafetyBIMIframe.contentWindow.model; 
      let element = iframeModelRef.BIM365API.Selector.getElementByElementID(['149e6926-a228-4931-82ca-972eb42fedaa^'+ele.modelid])
      let pos;
      if(element[0]) {
          pos = element[0].getElementPosition()
      }
      let img_icon = `${window.pubilc_config.locationurl}/safety-icon/${ele.icon}.png`;
      let pointeCallBack = iframeModelRef.BIM365API.Extension.Point.addAnchorPointByPosition(
          {
              x: pos.x + ele.x,
              y: pos.y + ele.y,
              z: pos.z + ele.z
          },
          img_icon
      );
      let panelHtml =  `<div class="${ele.icon}" id="${ele.idname}"
      style="width:63px;height:72px;background:url(${img_icon}) no-repeat center center;background-size:cover;"></div>`
      pointeCallBack.viewpointIcon.innerHTML = panelHtml;
      pointeCallBack.viewpointIcon.onclick = function(e) {
        console.log(e)
        _this.changeCameraSize = true;
        _this.bimCamerashow = true;
        // if (e.target.className == 'camera') {
        //   // 点击摄像头，打开监控视频，bimCamerashow = true;
          
        //     let _split =  e.target.id.split('-');
        //     let _id = _split[0];
        //     let _num = _split[1];
        //     _this.newGetCarmerFun(_id,_num,ele.titleName)
          
        // }
      }
    }, 
    // 添加两个箭头，暂时没有使用
    /*
    addINOutIcon(){
      let _this = this;
      let iframeModelRef = _this.$refs.progressSafetyBIMIframe.contentWindow.model; 
    
      let img_icon_s1 = `${window.pubilc_config.locationurl}/safety-icon/s1.png`;
      let pointeCallBack_s1 = iframeModelRef.BIM365API.Extension.Point.addAnchorPointByPosition(
          {
            x: 1099.7420075055586, y:  -1.1368683772161603e-13,z: -269.46967831365538
          },
          img_icon_s1
      );
      let panelHtml_s1 =  `<div class="s1" 
      style="width:104px;height:57px;
      background:url(${img_icon_s1}) no-repeat center center;
      background-size:cover;"></div>`
      pointeCallBack_s1.viewpointIcon.innerHTML = panelHtml_s1;

      let img_icon_s2 = `${window.pubilc_config.locationurl}/safety-icon/s2.png`;
      let pointeCallBack_s2 = iframeModelRef.BIM365API.Extension.Point.addAnchorPointByPosition(
          {
            x: 819.7420075055586, y:  -1.1368683772161603e-13,z: -499.46967831365538
          },
          img_icon_s2
      );
      let panelHtml_s2 =  `<div class="s1" 
      style="width:104px;height:57px;
      background:url(${img_icon_s2}) no-repeat center center;
      background-size:cover;"></div>`
      pointeCallBack_s2.viewpointIcon.innerHTML = panelHtml_s2;
    },
    */
    changeCamera(item){
      this.clickBIMCarmerSrc = item.carmerSrc;
      this.clickBIMCarmerName = item.carmerName;
      this.clickBIMCameraBigShow = true;
    },
    // 生成路径
    addPointOfFree(){
      let _this = this;
      //添加一个锚点
      let data = this.$refs.progressSafetyBIMIframe.contentWindow.model.BIM365API.Extension.Point.addAnchorPointByPosition(_this.addSegLinePointsArr,'')

      data.viewpointIcon.style.width = '22px'
      data.viewpointIcon.style.height = '30px'
      data.viewpointIcon.style.marginTop = '-15px'
      data.viewpointIcon.style.marginLeft = '2px'

      //更新锚点位置
      data.updatePosition()

      this.addSegLine();
    },
    // addPoint(){
    //   this.$refs.progressSafetyBIMIframe.contentWindow.model.BIM365API.Events.mouseDownEvent.on('default',this.addPointOfFree)
    // },
    // offAddPoint(){
    //   this.$refs.progressSafetyBIMIframe.contentWindow.model.BIM365API.Events.mouseDownEvent.off('default',this.addPointOfFree)
    // },

    // 生成路径的方法
    addSegLine(){ 
      this.$refs.progressSafetyBIMIframe.contentWindow.model.vector2DReService.addDynamicBound2(this.addSegLinePointsArr,'#409eff',3,200)
    },

    // addInLine(){ 
    //   this.$refs.progressSafetyBIMIframe.contentWindow.model.vector2DReService.addDynamicBound2(this.addInArr,'#409eff',0,0)
    // },

    // GetVideo接口返回所有监控，和监控名称，点击摄像头展示所有监控所用
    cameraSrcGetVideo(){
      let _this = this;
      _this.$axios
        .get(`${window.pubilc_config.webserverurl}/api/Video/Video/GetVideo`)
        .then(res => {
          if(res.data.Ret == 1){
            _this.allCameraSrcList = res.data.Data;
          }else{
            console.log(res,'======Video/Video/GetVideo')
          }
        }).catch(err => {
          _this.$message.error(err.data.Msg)
        })
    },
    // 之前逻辑，点击某个摄像头，尽然对应的监控
    /*
    newGetCarmerFun(id,num,title){
      let _this = this;
      _this.clickBIMCarmerName = title;
      _this.$axios
        .get(`${window.pubilc_config.webserverurl}/api/Video/Video/GetNewmas?deviceSerial=${id}&channelnumber=${num}`)
        .then(res => {
          if(res.data.Ret == 1){
            _this.clickBIMCarmerName = title;
            _this.clickBIMCarmerSrc = res.data.Data;
            _this.bimCamerashow = true;
          }else{
            console.log(res,'======Video/Video/GetNewmas')
          }
          // 接口请求成功后需要获取src，传给BIMCamera组件  为iframe的src，然后展示
        }).catch(err => {
          _this.$message.error(err.data.Msg)
        })
    },
    */
    clickCloseSize(){
      this.clickBIMCameraBigShow = false;
      this.changeCameraSize = true;
    }
  },
  watch: {},
  beforeDestroy: function() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  destroyed () {
    this.progressSafetyBIMSrc = '';
    clearTimeout(this.entertimer)
    clearTimeout(this.timer)
  }
};
</script>

<style lang="scss" scoped>
.content-left{
  overflow-x: auto !important;
}
.safety-left {
  .weather-line {
    height: 234px;
  }
  .safety-time {
    padding: 15px 0 20px 0;
    text-align: center;
    p {
      line-height: 38px;
    }
    .time-content{
      width: 250px;
      display: inline-block;
    }
    .font-64DD17 {
      margin: 40px 0 29px 0;
      line-height:0px;
      color: #64dd17;
      font-family: SourceHanSansCN;
      font-weight: 500;
    }
  }
  .in-case {
    padding: 13px 0 10px 20px;
    margin: 0px 20px 20px 20px;
    p {
      line-height: 34px;
      span {
        padding-right: 30px;
      }
      .padd10{
        font-family: 'AlibabaPuHuiTi-Regular';
        display: inline-block;
        margin-right: 10px;
      }
      .padd5{
        width: 10px;
      }
    }
  }
  .dangerous-tip {
    margin: 6px 20px 10px;
    max-height: 160px;
    overflow-y:auto;
    .tip-list {
      p {
        display: inline-block;
        vertical-align: middle;
        line-height: 40px;
        span {
          padding: 0 17px 0 12px;
        }
        i {
          vertical-align: middle;
        }
      }
      p.tip-first-child {
        margin: 0 40px 0px 29px;
        display: inline-block;
        span {
          display: inline-block;
          width: 80px;
          margin-left: 12px;
          padding: 0;
        }
      }
      .bg-biaoji {
        display: inline-block;
        width: 24px;
        height: 24px;
        background: url("../../assets/images/safety/biaoji.png") no-repeat;
        background-size: cover;
      }
      .quality_srike{
        background-image: url("../../assets/images/airDataBoard/safetyImageIcon/quality_srike.png");
      }
      .quality_fire{
        background-image: url("../../assets/images/airDataBoard/safetyImageIcon/quality_fire.png");
      }
      .quality_dke{
        background-image: url("../../assets/images/airDataBoard/safetyImageIcon/quality_dke.png");
      }
      .quality_mechianical{
        background-image: url("../../assets/images/airDataBoard/safetyImageIcon/quality_mechianical.png");
      }
      .quality_vehicleinjury{
        background-image: url("../../assets/images/airDataBoard/safetyImageIcon/quality_vehicleinjury.png");
      }
      .quality_craneinjury{
        background-image: url("../../assets/images/airDataBoard/safetyImageIcon/quality_craneinjury.png");
      }
      .quality_electricshock{
        background-image: url("../../assets/images/airDataBoard/safetyImageIcon/quality_electricshock.png");
      }
      .quality_burn{
        background-image: url("../../assets/images/airDataBoard/safetyImageIcon/quality_burn.png");
      }
      .quality_skydiving{
        background-image: url("../../assets/images/airDataBoard/safetyImageIcon/quality_skydiving.png");
      }
      .quality_collapse{
        background-image: url("../../assets/images/airDataBoard/safetyImageIcon/quality_collapse.png");
      }
      .quality_gunpowder{
        background-image: url("../../assets/images/airDataBoard/safetyImageIcon/quality_gunpowder.png");
      }
      .quality_otherdanger{
        background-image: url("../../assets/images/airDataBoard/safetyImageIcon/quality_otherdanger.png");
      }
    }
  }
}
.safety-right{
  position: relative;
  .BIM-camera{
    position: absolute;
    right: 10px;
    top: 10px; 
    background: #071129;
    z-index: 2;
  }
  .all-camera{
    position: absolute;
    right: 10px;
    top: 10px; 
    left: 10px;
    bottom: 10px;
    background: rgba(7,17,41,0.85);
    z-index: 2;
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    .css-camera-big{
      position: absolute;
      top:43px;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: calc(100% - 43px) !important;
      z-index: 1;
    }
    .children-camera{
      display: inline-block;
      width: calc(50% - 5px);
      height: calc(50% - 66px);
      z-index: 0;
    }
    .camera-content{
      width: 100%;
      height: 100%;
    }
    .children-camera:nth-child(odd){
      margin-left: 10px;
    }
    .children-camera-big{
      width: 100%;
      height: calc(100% - 43px);
      position: absolute;
      top: 43px;
      left: 0;
      z-index: 1;
      .vjs-custom-skin{
        width: 100%;
        height: 100%;
      }
    }
    
    .wapper-title {
      height: 42px;
      line-height: 42px;
      position: relative;
      background: linear-gradient(90deg, rgba(40, 153, 255, 0.2), rgba(57, 68, 121, 0.12));
    span {
      padding-left: 15px;
      font-size: 19px;
      font-family: SourceHanSansCN;
      font-weight: 500;
      color: #26abff;
    }
    .safety-icon {
      cursor: pointer;
      display: inline-block;
      width: 24px;
      height: 24px;
      position: absolute;
      top: 10px;
      background-image: url("../../assets/images/safety/size.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    } 
    .icon-size {
      right: 48px;
    }
    .icon-close {
      right: 10px;
      background-image: url("../../assets/images/safety/close.png");
    }
  }
  }
}
.camerasmall{
  width: 576px;
  height: 360px;
}
.camerabig{
  width: 1076px;
  height: 660px;
}
.p-r10{
  padding-right: 10px;
}
.p-l-r10{
  padding: 0 19px;
}
.safety-model{
  width: 100%;
  height: 100%;
  background: #b3c1cd;
}
</style>